module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/recruiting-d5885c018499e8a325c27ec2e4684f83.png";